const EMAIL_VALIDATION_REGEXP =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const PASSWORD_VALIDATION_REGEXP = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[A-Za-z\d\W]{8,}$/;

// A number greater than zero, optionally with decimals. Rejects '0', '0.00' and negatives.
const POSITIVE_AMOUNT_REGEXP = /^(?=.*[1-9])\d+(\.\d+)?$/;

// A whole number greater than zero.
const POSITIVE_INTEGER_REGEXP = /^[1-9]\d*$/;

// Digits only, the empty string included — for inputs that reject a non-digit keystroke outright
// instead of stripping it. Zero and leading zeros are left to POSITIVE_INTEGER_REGEXP on submit.
const DIGITS_ONLY_REGEXP = /^\d*$/;

export {
    EMAIL_VALIDATION_REGEXP,
    PASSWORD_VALIDATION_REGEXP,
    POSITIVE_AMOUNT_REGEXP,
    POSITIVE_INTEGER_REGEXP,
    DIGITS_ONLY_REGEXP,
};
